module.exports = __webpack_public_path__ + "media/img/specialize/mobile/item2-45e367d5b27993c6f42c2c2603010e33.svg";